import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../components/Navbar';
import SurveyPage from './SurveyPage';
import ProfilePage from './ProfilePage';
import LandingPage from './LandingPage';
import PrivateRoute from '../components/PrivateRoute';
import Matches from './Matches';
import Feed from './Feed';
import Register from './Register';
import VerifyUser from './VerifyUser';
import Login from './Login';
import {
  getUserData, toggleProfile, stopLoading, getProfilePhoto,
} from '../actions';
import Footer from '../components/Footer/component';
import RootPage from './DefaultPage';

export class App extends Component {
  async componentDidMount() {
    const token = localStorage.getItem('token');
    if (token) {
      await this.props.getUserData();
      await this.props.getProfilePhoto(this.props.answers.profile_photo?.answer);
    } else {
      this.props.stopLoading();
    }
  }

  render() {
    return (
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={RootPage} />
          <Route path="/landing" exact component={LandingPage} />
          <Route path="/verify" exact component={VerifyUser} />
          <Route path="/register" exact component={Register} />
          <Route path="/login" exact component={Login} />
          <PrivateRoute path="/feed" exact authenticated={this.props.authenticated} component={Feed} />
          <PrivateRoute path="/survey" exact authenticated={this.props.authenticated} component={SurveyPage} />
          <PrivateRoute path="/profile" exact authenticated={this.props.authenticated} component={ProfilePage} />
          <PrivateRoute path="/matches" exact authenticated={this.props.authenticated} component={Matches} />
          <Route component={() => (<div>Page not found.</div>)} />
        </Switch>
        <Footer />
      </Router>
    );
  }
}

export const mapStateToProps = state => (
  {
    authenticated: state.user.authenticated,
    profileOpen: state.user.profileOpen,
    answers: state.user.answers,
  }
);

export default connect(mapStateToProps, {
  getUserData, toggleProfile, stopLoading, getProfilePhoto,
})(App);
